import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Offices from '../../components/Offices/Offices';
import ContactSection from '../../components/ContactSection/ContactSection';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact-page flex flex-col min-h-screen">
      <Navbar />
      <div className="breadcrumb container">
        <span>首页</span>
        <span className="separator">|</span>
        <span>联系我们</span>
      </div>
      <ContactSection />
      {/* <Offices /> */}
      <div className='mt-auto'  style={{backgroundColor: '#f8f9fa'}}>
        <div className='container'>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Contact; 